import TableRow from "./table-row";

const TableBody = ({ rows }) => {
  return (
    <tbody className="divide-y divide-gray-200 bg-white">
      {rows.length > 0 ? (
        rows.map((row) => <TableRow key={row.id} row={row} />)
      ) : (
        <tr>
          <td
            colSpan={7}
            className="px-6 py-4 text-center text-sm text-gray-500"
          >
            No data available
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default TableBody;
